
import React from 'react';
import { Droppable } from 'react-beautiful-dnd';
import Card from './Card';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { connect } from 'react-redux';
import { IProductType, IColumn, ICard } from '../../shared/models/mainDashboardModel';
import { Link } from 'react-router-dom';

interface IProps {
    column: IColumn;
    canAdd: boolean;
    canEdit: boolean;
    canView: boolean;
    productTypes: IProductType[];
}

const Column = (props: IProps) => {
    const { column } = props;
    return (
        //  <li key={column.id} className="kanban-list">
        <div className="kanban-col">
            {/* ticket-wrp */}
            <div className="card-list">
                {/* ticket-title */}
                <div className="card-list-header">
                    <h3 className="mb-3">{column.name}</h3>
                    {props.canAdd && column.id === 'column_1' && (
                        <Dropdown>
                            <Dropdown.Toggle variant="outline-primary" className="btn btn-secondary create" id="dropdown-basic">
                                Create <FontAwesomeIcon icon={faPlusCircle} />
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                {props.productTypes.map((type: IProductType) =>
                                    <Dropdown.Item as={Link} key={type.id} to={{ pathname: '/return-note', state: { pt: type.id, col: +column.id.split('column_')[1] } }}>
                                        {type.name}
                                    </Dropdown.Item>)}
                            </Dropdown.Menu>
                        </Dropdown>)
                    }
                </div>
                <Droppable droppableId={column.id} direction="vertical" >
                    {(provided, snapshot) => {
                        // snapshot.isDraggingOver ?  document.body.classList.add('is-dragging') :  document.body.classList.remove('is-dragging');
                        // flex droppable-column clearFix
                        return (
                            <>
                                {/*     <div className="kanban-droppable-column">
                                <div style={{overflowX:"hidden",overflowY:"scroll",maxHeight:"800px"}} > */}
                                <div className="card-list-body" ref={provided.innerRef}
                                    data-is-dragging-over={snapshot.isDraggingOver}
                                    {...provided.droppableProps}>
                                        {column.items.map((card: ICard, index: number) => <Card
                                            canView={props.canView} canEdit={props.canEdit} key={column.id + '_' + card.id} columnId={column.id} card={card} index={index} />)}
                                        {provided.placeholder}
                                </div>

                                {/* </div>
                               </div> */}
                            </>)
                    }
                    }
                </Droppable>
            </div>
        </div>
        // </li> 
    );
}

const mapStateToProps = (state: any) => ({
    productTypes: state.mainDashboard.productTypes,
})

export default connect(mapStateToProps)(Column)